import Router from './components/router'

//import contexts
import LanguageContextProvider from './context/languageContext/LanguageContext';
import MenuContextProvider from './context/menuContext/MenuContext';

export default function App() {

  return (
    <LanguageContextProvider >
      <MenuContextProvider>
        <Router />
      </MenuContextProvider>
    </LanguageContextProvider>
  );
}
